import { IActionContext } from '../helpers/ActionContext';
import { CommonErrorCode, ProjectErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { Module } from '../Module';
import { Projects } from '../resources/Projects';
import { IError } from '../ServerApi/types/IError';
import { IResult } from '../ServerApi/types/IResponse';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ToasterService, ToastType } from './ToasterService';

interface ICreateProjectDialogScope extends ng.IScope {
  dialog: {
    name: string;
    description: string;
  };
  maxDescriptionLength: number;
}

const MAX_DESCRIPTION_LENGTH = 4000;

export class CreateProjectAction {

  public static $inject = ['ConfirmActionDialog', '$translate', 'ToasterService', 'Projects'];

  constructor(
    private ConfirmActionDialog: ConfirmActionDialog,
    private $translate: ng.translate.ITranslateService,
    private toaster: ToasterService,
    private Projects: Projects) { }

  public execute(actionContext: IActionContext, parentId?: string): ng.IPromise<IResult> {

    const dialogScope = <ICreateProjectDialogScope> actionContext.scope.$new();
    dialogScope.dialog = {
      name: '',
      description: '',
    };
    dialogScope.maxDescriptionLength = MAX_DESCRIPTION_LENGTH;

    return this.ConfirmActionDialog.open({
      scope: dialogScope,
      title: this.$translate.instant('createProjectDialogTitle'),
      bodyTemplateUrl: 'createProjectDialog.html',
      position: { reserveHeight: 800 },
      confirmDisabled: () => dialogScope.dialog.description.length > dialogScope.maxDescriptionLength,
      actionName: this.$translate.instant('createProjectDialogSubmit'),
      action: (dialogInstance: IConfirmActionDialogInstance) => {

        return this.Projects.create(dialogScope.dialog.name, dialogScope.dialog.description, parentId)
          .then((result: IResult) => {
            if (result.errors && result.errors.length) {
              dialogInstance.showErrorMessage(this.errorMessage(result.errors));
            } else {
              this.toaster.pop({

                type: ToastType.Info,
                text: this.$translate.instant('createProjectSuccess', {
                  PROJECT_NAME: L10n.elideIfLong(dialogScope.dialog.name)
                })

              });
            }
            return result;
          })
          .catch((reason: any) => {
            dialogInstance.showErrorMessage(this.errorMessage([{code: reason}]));
          });
      }
    }).result.finally(() => dialogScope.$destroy());
  }

  private errorMessage(errors: IError[]) {
    switch (errors[0].code) {
      case ProjectErrorCode.ProjectNameAlreadyExists:
        return this.$translate.instant('errorProjectNameAlreadyExists');
      case CommonErrorCode.CallingUserInsufficientPermissions:
        return this.$translate.instant('projectCreationError_insufficientPermissions');
      default:
        return this.$translate.instant('createProjectFailed');
    }
  }

}

Module.instance().service('CreateProjectAction', CreateProjectAction);
